module.exports = __webpack_public_path__ + "static/metalworkMachine-6c669a0943ae17909f39c22bc1d22e88.jpg";